import { render, staticRenderFns } from "./SecurityCenter.vue?vue&type=template&id=2df4c3f4&scoped=true&"
import script from "./SecurityCenter.vue?vue&type=script&lang=ts&"
export * from "./SecurityCenter.vue?vue&type=script&lang=ts&"
import style0 from "./SecurityCenter.vue?vue&type=style&index=0&id=2df4c3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df4c3f4",
  null
  
)

export default component.exports